class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    
    // Add submission lock
    this.isSubmittingFromSummary = false;

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    const applyFiltersButton = this.querySelector('.apply_filters-button'); 
    
    // Apply filters button listener
    if (applyFiltersButton) {
      applyFiltersButton.addEventListener('click', this.onSubmitHandler.bind(this));
    }

    document.querySelectorAll('.mobile-facets__disclosure .mobile-facets__open-wrapper')
      .forEach(summary => {
        summary.addEventListener('click', (event) => {
          // Prevent multiple rapid triggers
          if (this.isSubmittingFromSummary) return;

          setTimeout(() => {
            const isExpanded = summary.getAttribute('aria-expanded') === 'true';
            if (isExpanded) return;

            // ✅ Only apply if at least one checkbox is checked
            const form = summary.closest('menu-drawer')?.querySelector('form');
            if (!form) return;

            const hasChecked = form.querySelector(
              'input[type="checkbox"]:checked'
            );

            if (!hasChecked) return;

            // ✅ Check if URL would actually change
            const newSearchParams = this.createSearchParams(form);
            const currentSearchParams = window.location.search.slice(1);
            
            // Normalize both params for comparison
            const normalizedNew = new URLSearchParams(newSearchParams).toString();
            const normalizedCurrent = new URLSearchParams(currentSearchParams).toString();
            
            if (normalizedNew === normalizedCurrent) {
              console.log('URL unchanged, skipping submit');
              return;
            }
            applyFiltersButton.click();


            this.isSubmittingFromSummary = true;

            // Reset lock after submit
            setTimeout(() => {
              this.isSubmittingFromSummary = false;
            }, 100);

          }, 100);
        });
      });


    this.filterBtnStatus();

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Add sort change listeners - Apply immediately on change
    this.addSortListeners();
  }

  // NEW METHOD: Add sort listeners to all sort dropdowns
  addSortListeners() {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.addEventListener('change', this.onSortChange.bind(this));
    });
  }

  // NEW METHOD: Handle sort change - applies immediately
  onSortChange(event) {
    event.preventDefault();

    const selectedValue = event.target.value;

    // Start with current URL params to preserve any active filters already in the URL
    const params = new URLSearchParams(window.location.search);

    // If the change came from the mobile form, merge mobile form values (they may not be in the URL yet)
    const form = event.target.closest('form');
    if (form && form.id === 'FacetFiltersFormMobile') {
      const mobileParams = new URLSearchParams(this.createSearchParams(form));
      for (const [key, value] of mobileParams.entries()) {
        params.set(key, value);
      }
    }

    // Always set the selected sort
    params.set('sort_by', selectedValue);

    // When changing sort, go back to the first page if pagination is present
    if (params.has('page')) params.delete('page');

    // Clean up no-js lists (same as before)
    document.querySelectorAll('.no-js-list').forEach((el) => el.remove());

    // Apply sort immediately while preserving active filters
    this.onSubmitForm(params.toString(), event);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
        // Re-attach sort listeners after page update
        FacetFiltersForm.reattachSortListeners();
        FacetFiltersForm.reinitCustomDropdowns();
        
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    // Re-attach sort listeners after cache render
    FacetFiltersForm.reattachSortListeners();
    FacetFiltersForm.reinitCustomDropdowns();
    
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }
  
  static reinitCustomDropdowns() {
    // Find all custom sort dropdown elements
    const dropdowns = document.querySelectorAll('custom-sort-dropdown');
    
    dropdowns.forEach(dropdown => {
      // Force re-initialization by disconnecting and reconnecting
      const clone = dropdown.cloneNode(true);
      dropdown.parentNode.replaceChild(clone, dropdown);
    });
  }

  // NEW METHOD: Re-attach sort listeners after DOM update
  static reattachSortListeners() {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      // Remove old listeners
      const clone = select.cloneNode(true);
      select.parentNode.replaceChild(clone, select);
      
      // Add new listener
      const facetForm = clone.closest('facet-filters-form');
      if (facetForm) {
        clone.addEventListener('change', facetForm.onSortChange.bind(facetForm));
      }
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    if (!count) {
      const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
      loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
      const containerDesktop = document.getElementById('ProductCountDesktop');
      if (containerDesktop) {
        containerDesktop.classList.remove('loading');
      }
      return;
    } 
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }

    // Re-initialize accordion-animated elements after DOM updates to restore event listeners and references
    FacetFiltersForm.refreshAccordionAnimated();
  }

  // NEW STATIC METHOD: Refresh all accordion-animated elements after rendering
  static refreshAccordionAnimated() {
    document.querySelectorAll('accordion-animated').forEach((item) => {
      if (typeof item.refresh === 'function') {
        item.refresh();
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileDrawer = document.getElementById('FacetFiltersFormMobile').closest('menu-drawer');
    if (mobileDrawer && typeof mobileDrawer.bindEvents === 'function') mobileDrawer.bindEvents();
    attachMobileCloseEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  filterBtnStatus() {
    const applyFiltersButton = document.querySelector('.apply_filters-button');
    const facetForm = this.querySelector('form');   

    if (!facetForm) return;
    const checkboxes = Array.from(facetForm.querySelectorAll('input[type="checkbox"]'));
      
    // Check if at least one checkbox is checked
    const hasChecked = checkboxes.some(checkbox => checkbox.checked);
    // Toggle the button
    applyFiltersButton.classList.toggle('disabled', !hasChecked);

    facetForm.addEventListener('change', () => {
      // Get all checkboxes in the form
      const checkboxes = Array.from(facetForm.querySelectorAll('input[type="checkbox"]'));
      
      // Check if at least one checkbox is checked
      const hasChecked = checkboxes.some(checkbox => checkbox.checked);

      // Toggle the button
      applyFiltersButton.classList.toggle('disabled', !hasChecked);
    });
  }
  
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile' || event.target.closest('menu-drawer')?.querySelector('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      
      const newSearchParams = forms.join('&');
      
      // ✅ Check if URL would actually change before submitting
      const currentSearchParams = window.location.search.slice(1);
      const normalizedNew = new URLSearchParams(newSearchParams).toString();
      const normalizedCurrent = new URLSearchParams(currentSearchParams).toString();
      
      if (normalizedNew === normalizedCurrent) {
        console.log('URL unchanged, skipping submit from onSubmitHandler');
        return;
      }
      
      this.onSubmitForm(newSearchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function attachMobileCloseEvents() {
  document.querySelectorAll('.mobile-close__factes').forEach((el) => {
    if (el.dataset.mobileCloseBound) return;
    el.dataset.mobileCloseBound = 'true';
    el.setAttribute('role', 'button');
    el.tabIndex = 0;

    el.addEventListener('click', (event) => {
      event.preventDefault();
      const wrapper = el.closest('.mobile-facets__wrapper');
      const menuDrawer = wrapper.closest('menu-drawer');

      // Reset facets to match current URL filters
      const urlParams = new URLSearchParams(window.location.search);
      const form = wrapper.querySelector('form');
      if (form) {
        form.querySelectorAll('input[type="checkbox"]').forEach(cb => {
          const name = cb.name;
          const value = cb.value;
          const isInUrl = urlParams.getAll(name).includes(value);
          cb.checked = isInUrl;
        });
        form.querySelectorAll('input[type="radio"]').forEach(rb => {
          const name = rb.name;
          const value = rb.value;
          const isInUrl = urlParams.get(name) === value;
          rb.checked = isInUrl;
        });
      }

      // Close any open disclosures
      wrapper.querySelectorAll('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
      // Reset any active classes
      wrapper.querySelectorAll('.active, .open, .is-active').forEach(el => {
        el.classList.remove('active', 'open', 'is-active');
      });

      menuDrawer.closeMenuDrawer(event);
    });

    el.classList.remove('mobile-facets__close--no-js');
  });
}
attachMobileCloseEvents();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const link = this.querySelector('a');
    if (!link) return;

    link.setAttribute('role', 'button');
    link.addEventListener('click', this.onRemove.bind(this));
  }

  onRemove(event) {
    event.preventDefault();

    const facetForm =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');

    const menuDrawer = this.closest('menu-drawer');
    
    if (!facetForm) return;

    const form = facetForm.querySelector('form');

    const checkedInputs = form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

    checkedInputs.forEach(input => { input.checked = false; });
    if (menuDrawer) {
      const DrawerClose = menuDrawer.querySelector('.mobile-facets__close');
      DrawerClose?.click();      
    }

    facetForm.querySelectorAll('accordion-animated').forEach(acc => {
      acc.close?.();
    });

    facetForm.querySelectorAll('[aria-expanded="true"]').forEach(el => {
      el.setAttribute('aria-expanded', 'false');
    });

    facetForm.querySelectorAll('.active, .open, .is-active').forEach(el => {
      el.classList.remove('active', 'open', 'is-active');
    });

    facetForm.filterBtnStatus();

    if (window.location.href.includes('?')) {
      facetForm.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);